import React, { memo, forwardRef } from 'react';
import { Typography } from '@mui/material';
import { AddLinearIcon } from '../../icons-lib';
import PropTypes from 'prop-types';
import { AddAssociatedButton, AssociatedBox } from './styles';

const AddAssociatedComponent = forwardRef(({ label, onClick }, ref) => {
    return (
        <AssociatedBox ref={ref}>
            <AddAssociatedButton onClick={onClick}>
                <AddLinearIcon />
            </AddAssociatedButton>
            <Typography variant="body1" sx={{ ml: 2 }}>
                {label}
            </Typography>
        </AssociatedBox>
    );
});

AddAssociatedComponent.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
};

export default memo(AddAssociatedComponent);
